import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title \"Site Audit\"}}\n{{page-title \"Create View\"}}\n\n<NwSiteAuditPage @model={{this.model}} />")